import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { takeUntil, first } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthenticationService } from 'app/auth/service';
import { CoreConfigService } from '@core/services/config.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import MetaMaskOnboarding from '@metamask/onboarding';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  //  Public
  public coreConfig: any;
  public loginForm: FormGroup;
  public loading = false;
  public submitted = false;
  public returnUrl: string;
  public error = '';
  public passwordTextType: boolean;
  // Private
  private _unsubscribeAll: Subject<any>;
  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   */
  constructor(
    private _coreConfigService: CoreConfigService,
    private _formBuilder: FormBuilder,
    private _route: ActivatedRoute,
    private _router: Router,
    private _authenticationService: AuthenticationService,
    public modalService: NgbModal
  ) {
    this._unsubscribeAll = new Subject();
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }

  /**
   * Toggle password
   */
  togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }

    // Login
    this.loading = true;
    this._authenticationService
      .login(this.f.email.value, this.f.password.value)
      .pipe(first())
      .subscribe(
        data => {
          this.error = '';
          const { code , message, user } = data || {};
          if(code == 1001) {
            let userInfo = this._authenticationService.currentUserValue.user;
            if(userInfo.role == 'admin'){
              this._router.navigate(['/admin']);
            } else {
              if(userInfo.defaultProduct == 'CRYPTO'){
                this._router.navigate(['/crypto/performance']);
              } else {
                this._router.navigate(['/stock/performance']);
              }
              // else if(userInfo.defaultProduct == 'NFT'){
              //   this._router.navigate(['/nft']);
              // }
            }
            this._authenticationService.removeUser();
            this.modalService.dismissAll();
          }
          // else if(code == 1001 && (user.subscriptionStatus !== 'paid')) {
          //   this._router.navigate(['subscription']);
          // }
          else {
            this.loading = false;
            this.error = message
          }
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.loginForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });

    // get return url from route parameters or default to '/'
    this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';

    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  /* when wallet connect */
  isWalletConnet(event){
    if(event){
      this.modalService.dismissAll();
    }
  }

  public installMetaMask(){
    const onboarding = new MetaMaskOnboarding();
    onboarding.startOnboarding();
  }
}
